<prism-floating-dialog
	id="sh-chat-assistant-prism-dialog"
	#chatComponent
	*transloco="let t; read: 'cloud.shared.chat-assistant'"
	(prismDialogClose)="onDialogClose()"
>
	<span slot="title" id="sh-chat-assistant-prism-dialog-title">
		<div id="sh-chat-assistant-prism-dialog-title-content">
			<prism-icon id="sh-chat-assistant-awesome-icon" icon="auto_awesome"></prism-icon>
			<span id="sh-chat-assistant-prism-dialog-title-text"> {{ t('intellimix-agent') }} </span>
			<span id="sh-chat-assistant-prism-dialog-beta" class="prism-button">{{ t('beta') | uppercase }}</span>
		</div>
	</span>
	<div id="sh-chat-assistant-prism-dialog-body-div">
		<div id="sh-chat-assistant-prism-dialog-new-chat-div">
			<prism-button
				id="sh-chat-assistant-prism-dialog-new-chat-button"
				variant="text"
				size="small"
				(click)="emptyMessageList()"
			>
				{{ t('new-chat') }}
			</prism-button>
		</div>
		<hr id="sh-chat-assistant-prism-dialog-divider" class="prism-divider" orientation="horizontal" />
		<div id="sh-chat-assistant-prism-dialog-messages-list-div" #messagesListDiv>
			<div id="sh-chat-assistant-prism-dialog-message-info-text" class="prism-caption">
				<div id="sh-chat-assistant-reload-warning">{{ t('reload-warning-text') }}</div>
				<div id="sh-chat-assistant-consent-text">{{ t('consent-text') }}</div>
			</div>
			<div id="sh-chat-assistant-prism-dialog-default-message" class="bot-message-style">
				{{ trimResponse(t('default-message')) }}
			</div>
			@for (message of messagesList(); track $index) {
				<ng-container [ngSwitch]="message.type">
					<ng-container *ngSwitchCase="'waiting_for_input'">
						<div id="sh-chat-assistant-prism-dialog-bot-message-{{ $index }}" class="bot-message-style">
							<prism-radio-group
								id="sh-chat-assistant-radio-group-{{ $index }}"
								(valueChange)="selectedOption.set($event.detail)"
								[disabled]="$index !== messagesList().length - 1"
							>
								<span slot="group-title" id="sh-chat-assistant-radio-group-title-{{ $index }}">{{
									t('select-option')
								}}</span>
								@for (option of message.options; track option) {
									<prism-radio-button
										id="sh-chat-assistant-radio-button-{{ $index }}-{{ option }}"
										[value]="option"
										>{{ option }}</prism-radio-button
									>
								}
							</prism-radio-group>
							<div id="sh-chat-assistant-prism-dialog-option-submit-button-div-{{ $index }}">
								<prism-button
									id="sh-chat-assistant-prism-dialog-option-submit-button-{{ $index }}"
									class="sh-chat-assistant-prism-dialog-option-submit-button"
									variant="bright"
									(click)="submitSelectedOption()"
									[disabled]="
										$index !== messagesList().length - 1 ||
										selectedOption() === '' ||
										isResponseGenerating()
									"
								>
									{{ t('submit') }}
								</prism-button>
							</div>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'final_state'">
						@if (message.role === 'user') {
							<div
								id="sh-chat-assistant-prism-dialog-user-message-{{ $index }}"
								class="user-message-style"
							>
								{{ message.content }}
							</div>
						} @else {
							<div
								id="sh-chat-assistant-prism-dialog-bot-message-container-{{ $index }}"
								class="sh-chat-assistant-prism-dialog-bot-message-container"
							>
								<markdown
									id="sh-chat-assistant-prism-dialog-bot-message-{{ $index }}"
									[data]="message.content"
									class="bot-message-style"
								>
								</markdown>
								@if (message?.isFinalResponse) {
									<div
										id="sh-chat-assistant-prism-dialog-feedback-buttons-div-{{ $index }}"
										class="sh-chat-assistant-prism-dialog-feedback-buttons-div"
									>
										<prism-icon-button
											id="sh-chat-assistant-prism-dialog-thumbs-up-button-{{ $index }}"
											icon="thumb_up"
											[disabled]="
												message.feedbacktype === userFeedbackEnum.Negative ||
												(feedBackDataSignal().feedbacktype === userFeedbackEnum.Negative &&
													feedBackDataSignal().messageId === message.messageId)
											"
											toggle
											(valueChange)="
												setFeedbackType(
													$event.detail
														? userFeedbackEnum.Positive
														: userFeedbackEnum.Neutral,
													message
												)
											"
										></prism-icon-button>
										<prism-icon-button
											id="sh-chat-assistant-prism-dialog-thumbs-down-button-{{ $index }}"
											icon="thumb_down"
											[disabled]="
												message.feedbacktype === userFeedbackEnum.Positive ||
												(feedBackDataSignal().feedbacktype === userFeedbackEnum.Positive &&
													feedBackDataSignal().messageId === message.messageId)
											"
											toggle
											(valueChange)="
												setFeedbackType(
													$event.detail
														? userFeedbackEnum.Negative
														: userFeedbackEnum.Neutral,
													message
												)
											"
										></prism-icon-button>
										<prism-icon-button
											id="sh-chat-assistant-prism-dialog-copy-button-{{ $index }}"
											icon="content_copy"
											(click)="copyResponseToClipboard(message.content)"
										></prism-icon-button>
									</div>
								}
								@if (
									feedBackDataSignal().feedbacktype !== userFeedbackEnum.Neutral &&
									feedBackDataSignal().messageId === message.messageId
								) {
									<div
										id="sh-chat-assistant-feedback-form-div-{{ $index }}"
										class="sh-chat-assistant-feedback-form-div"
									>
										<div
											id="sh-chat-assistant-feedback-title-{{ $index }}"
											class="prism-body-1 sh-chat-assistant-feedback-title"
										>
											{{ t('why-did-you-choose-this-rating') }}
										</div>
										<form [formGroup]="assistantResponseFeedbackForm">
											<div
												id="sh-chat-assistant-feedback-option-buttons-div-{{ $index }}"
												class="sh-chat-assistant-feedback-option-buttons-div"
											>
												@for (
													feedback of assistantResponseFeedbackLabels[
														feedBackDataSignal().feedbacktype
													];
													track feedback
												) {
													<prism-button
														id="sh-chat-assistant-feedback-option-button-{{ $index }}-{{
															feedback.key
														}}"
														variant="toggle"
														swap="false"
														checked="false"
														size="md"
														type="button"
														(valueChange)="feedBackOnSelect(feedback.label, $event.detail)"
														[checked]="userFeedbackButtonSignals[feedback.key]()"
														>{{ t(feedback.key) }}
													</prism-button>
												}
											</div>
											<div>
												<prism-textarea
													id="sh-chat-assistant-feedback-response-{{ $index }}"
													placeholder="{{ t('provide-additional-feedback') }}"
													class="sh-chat-assistant-feedback-response-textarea"
													rows="1"
													formControlName="userFeedbackText"
													autofocus="true"
												>
												</prism-textarea>
											</div>
											<div
												id="sh-chat-assistant-feedback-submit-buttons-div-{{ $index }}"
												class="sh-chat-assistant-feedback-submit-buttons-div"
											>
												<prism-button (click)="onCloseFeedback()"
													>{{ t('do-not-provide-details') }}
												</prism-button>
												<prism-button
													variant="bright"
													[disabled]="
														userFeedbackOptionControl.value === '' &&
														userFeedbackTextControl.value === ''
													"
													(click)="submitFeedbackDetails()"
													>{{ t('submit') }}
												</prism-button>
											</div>
										</form>
									</div>
								}
								@if (
									feedBackSubmittedSignal().submitted === 'true' &&
									feedBackSubmittedSignal().messageId === message.messageId
								) {
									<span>{{ t('feedback-submitted') }}</span>
								} @else if (
									feedBackSubmittedSignal().submitted === 'error' &&
									feedBackSubmittedSignal().messageId === message.messageId
								) {
									<span>{{ t('error-message') }}</span>
								}
							</div>
						}
					</ng-container>
				</ng-container>
			}

			@if (isResponseGenerating()) {
				<div class="bot-message-style" id="sh-chat-assistant-loading-div">
					{{ trimResponse(t('generating-response')) }}
					<span id="sh-chat-assistant-dots" class="loading-dots">
						<span class="dot">.</span>
						<span class="dot">.</span>
						<span class="dot">.</span>
					</span>
				</div>
			} @else if (displayErrorMessage()) {
				<div class="bot-message-style" id="sh-chat-assistant-error-div">
					{{ trimResponse(t('error-message')) }}
				</div>
			}
		</div>
		<div id="sh-chat-assistant-prism-dialog-footer-div">
			<form [formGroup]="formGroup">
				<prism-textarea
					id="sh-chat-assistant-prism-dialog-input"
					formControlName="chatInput"
					autofocus="true"
					placeholder="{{ t('ask-a-question') }}"
					multiline="true"
					rows="2"
					max-rows="6"
				>
				</prism-textarea>
				<prism-icon-button
					id="sh-chat-assistant-prism-dialog-send-button"
					[disabled]="formGroup.invalid"
					icon="send"
					(click)="submitMessage()"
				>
				</prism-icon-button>
			</form>
		</div>
	</div>
</prism-floating-dialog>
